import { createOidcConfig, loadStoredUser } from '@medcom/shared-ui/utils/oidc.ts';

export const oidcConfig = createOidcConfig(window._env_.KEYCLOAK_URL, 'labrador-ui');

export const loadUser = () => loadStoredUser(oidcConfig);
